<template>
    <div id="app">
        <Heade>
            <template v-slot:back ><img src="../../assets/img/02-2左new.png" alt="" @click="$router.push('/RebroadcastList')"></template>
            <template v-slot:title>会议回看</template>
        </Heade>
        <div class="video">
            <div class="prism-player" id="player-con" style="height:202px"></div>
            <div class="transmitNumber" v-show="isTransmitNumber">
                <img src="../../assets/img/bofang.png" alt="">
                <span>{{transmitNumber}}</span>
            </div>
        </div>
        <div class="myTab">
            <div @click="isShow = true">聊天互动 <span v-show="isShow"></span></div>
            <div @click="isShow = false">会议日程 <span v-show="!isShow"></span></div>
        </div>

        <div class="content" v-show="isShow" id="con"  :style="{height: curHeight + 'px'}">
            <div id="personCon">
                <div class="person" v-for="(item,index) in CommentList" :key="index">
                    <div class="name">
                        <div class="img"><img src="../../assets/img/headPortrait.png" alt=""></div>
                        <div class="txt">{{item.nick_name}}</div>
                    </div>
                    <div>                   
                        <div class="discuss" v-if="item.comment.name">送给{{item.comment.name}}<img style="width: 40px;height:40px;margin-top:-8px;" :src="item.comment.src" alt="">，数量:{{item.comment.number}}</div>
                        <div class="discuss" v-else>{{item.comment}}</div>
                    </div> 
                    <div class="date">{{item.send_time}}</div>
                </div>
            </div>
            <div class="more" @click="getComment" v-if="isLoad">正在努力加载中~</div>
        </div>

        <div class="schedule" v-show="!isShow" id="sch"  :style="{height: curHeight + 'px'}">
            <img style="height:auto;" :src="schedule_url" alt="">
        </div>
    </div>
</template>
    <style>
        .video-dimensions {
            width: 100%;
        }
    </style>

    <script>
        export default {
            data(){
                return {
                    message: 3,
                    isShow: true,
                    meeting_field: '',//会议场次
                    id: '',//会议id
                    video_id: '',//视频ID
                    schedule_url: '',//日程表地址
                    video_cover_url: '',//视频封面
                    CommentList: [],//评论列表
                    num: 0,
                    arr: [],
                    isLoad: false,
                    transmitNumber: 0,//播放数量
                    isTransmitNumber: true,
                    curHeight: 0
                }
            },
            mounted() {
                this.meeting_field = this.$route.query.meeting_field;
                this.id = this.$route.query.id;
                this.video_id = this.$route.query.video_id;
                this.playVideo(this.video_id);
                this.getPath();
                this.getComment();
                this.getHeiht();
            },
            methods: {
                //播放视频。
                playVideo(videoId) {
                    const _this = this;
                    this.axios.post("/api/video/getAliyunVideoPlayAuth", { videoId: videoId }).then(res => {
                        let data = res.data
                        if (data.code === "00000") {
                            console.log(data.model.playAuth);
                            console.log(data.model.coverUrl);

                            var player = new Aliplayer({
                                "id": "player-con",
                                "vid": videoId,
                                "playauth": data.model.playAuth,
                                "cover": data.model.coverUrl,
                                "width": "100%",
                                "height": "433px",
                                "autoplay": false,
                                "isLive": false,
                                "rePlay": false,
                                "playsinline": true,
                                "preload": true,
                                "controlBarVisibility": "hover",
                                "useH5Prism": true
                            }, function (player) {
                                console.log("The player is created");
                                // player.play();
                                player.on('play', function (e) {
                                    console.log('播放开始')
                                    _this.isTransmitNumber = false;
                                });
                            }
                            );

                        } else {
                            alert("获取播放授权码错误，请返回重试。");
                        }
                    })
                },
                //获取视频地址图片地址
                getPath() {
                    var _this = this;
                    var params = {
                        id: this.id
                    }
                    // $.ajax({
                    //     url: basePath + "/api/videoRecord/getVideoRecordInfo",
                    //     contentType: false,
                    //     type: "post",
                    //     data: JSON.stringify(data),
                    //     success: function (res) {
                    //         _this.video_cover_url = res.model.video_cover_url;
                    //         _this.schedule_url = res.model.schedule_url;
                    //         const num = res.model.view_num;
                    //         //const num = 10800;
                    //         _this.transmitNumber = num > 9999 ? (num / 10000).toFixed(1) + '万' : num;
                    //         //_this.path = res.model.path;
                    //         _this.setVideo();
                    //     },
                    //     error: function (jqXHR, textStatus, errorThrown) {
                    //         console.log('接口错误')
                    //     }
                    // });
                    const url = "/api/videoRecord/getVideoRecordInfo";
                    this.axios.post(url,params,
                    { transformRequest: function (params) {return JSON.stringify(params);},
                    headers: {'Content-Type': 'application/json;charset=UTF-8'}
                    }).then(res => {
                        console.log('smfksdjf',res);
                        // if (res.data.code === "00000") {
                            _this.video_cover_url = res.data.model.video_cover_url;
                            _this.schedule_url = res.data.model.schedule_url;
                            const num = res.data.model.view_num;
                            //const num = 10800;
                            _this.transmitNumber = num > 9999 ? (num / 10000).toFixed(1) + '万' : num;
                            //_this.path = res.model.path;
                            _this.setVideo();
                        // }
                    });
                },
                //获取评论
                getComment() {
                    var _this = this;
                    this.num++
                    var params = {
                        meeting_field: _this.meeting_field,
                        pageNum: this.num,
                        pageSize: 10,
                    }
                    const url = "/api/videoRecord/meetingCommentList";
                    this.axios.post(url,params,
                    { transformRequest: function (params) {return JSON.stringify(params);},
                    headers: {'Content-Type': 'application/json;charset=UTF-8'}
                    }).then(res => {
                        console.log('res',res.data.code,res.data.model.list);
                        if (res.data.code === "00000") {
                            if (res.data.model.list.length) {
                                res.data.model.list.forEach(item => {                                        
                                    if(_this.checkJson(item.comment)){
                                        item.comment = JSON.parse(item.comment)
                                    }
                                    _this.arr.push(item);
                                })
                                _this.CommentList = _this.arr;                                    
                                _this.isLoad = true;
                            } else {
                                _this.isLoad = false;
                            }
                        }
                    });
                    // $.ajax({
                    //     url: basePath + "/api/videoRecord/meetingCommentList",
                    //     contentType: false,
                    //     type: "post",
                    //     data: JSON.stringify(data),
                    //     success: function (res) {
                    //         if (res.code === '00000') {
                    //             if (res.model.list.length) {
                    //                 res.model.list.forEach(item => {                                        
                    //                     if(_this.checkJson(item.comment)){
                    //                         item.comment = JSON.parse(item.comment)
                    //                     }
                    //                     _this.arr.push(item);
                    //                 })
                    //                 _this.CommentList = _this.arr;                                    
                    //                 _this.isLoad = true;
                    //             } else {
                    //                 _this.isLoad = false;
                    //             }

                    //         } else if (res.code === '11111') {
                    //             // window.location.href="../login.html";
                    //         }
                    //     },
                    //     error: function (jqXHR, textStatus, errorThrown) {
                    //         console.log('接口错误')
                    //     }
                    // });
                },
                checkJson(str) {
                    if (typeof str == 'string') {
                        try {
                            var obj=JSON.parse(str);
                            if(typeof obj == 'object' && obj ){
                                return true;
                            }else{
                                return false;
                            }

                        } catch(e) {
                            return false;
                        }
                    }
                },
                //获取屏幕高度计算评论区的高度
                getHeiht() {
                    var _this = this;
                    var timeTout;
                    var H = document.documentElement.clientHeight || document.body.clientHeight; 
                    var newH = H - 300;
                    this.curHeight = newH
                    this.$nextTick(() => {
                        document.getElementById('con').scroll(function () {
                            clearTimeout(timeTout)
                            var $this = $(this),
                                viewH = $(this).height(),//可见高度
                                contentH = $(this).get(0).scrollHeight,//内容高度
                                scrollTop = $(this).scrollTop();//滚动高度
                            if (scrollTop / (contentH - viewH) >= 0.95) { //到达底部100px时,加载新内容
                                // 这里加载数据..
                                timeTout = setTimeout(function () {
                                    _this.getComment();
                                }, 100)
                            }
                        })
                    })

                },
                //返回
                goBack() {
                    this.$router.push('/RebroadcastList')
                    // window.location.href = "./playbackList.html";
                },
                //配置video
                setVideo() {
                    var options = {
                        controls: 'control',
                        preload: 'none',
                        height: '422',
                    };
                    var player = videojs('video', options)

                    //待切换的视频源
                    var newVideo = this.path;
                    //console.log(newVideo,'666666')
                    //暂停视频
                    player.pause()
                    //获取视频节点（也就是video元素）
                    //值的注意的是，想通过id或者class获取该节点的时候，要注意video前后渲染的时候id和class改变了
                    //请使用渲染后的id或者class
                    //比如，这个原来的id是video，渲染后变成了video1_html5_api
                    var $video = $('video_html5_api')
                    $video.attr('src', newVideo)
                    //重载视频
                    player.load()
                    //开始视频
                    player.play()
                },
                //处理地址
                // getQueryString(name) {
                //     var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
                //     var r = window.location.search.substr(1).match(reg);
                //     if (r != null) return unescape(r[2]);
                //     return null;
                // }
            }
        }
    </script>
    <style lang="less" scoped>
       html,body{
    background: #f2f2f2;
}
.title{
    width: 100%;
    height: 82px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    position: relative;
    .back{
        position: absolute;
        top: 20px;
        left: 30px;
        img{
            width: 15px;
            height: 26px;
        }
    }
}
.video{
    width: 100%;
    height: 422px;
    background: #ffffff;
    position: relative;
    .transmitNumber{
        position: absolute;
        top: 22px;
        right: 30px;
        font-size: 24px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 100;
        img{
            margin-right: 12px;
        }
    }
}
.myTab{
    width: 100%;
    height: 82px;
    display: flex;
    align-items: center;
    background: #ffffff;
    border-bottom: 1px solid #c7c8c9;
    div{
        font-size: 32px;
        font-weight: bold;
        color: #000;
        width: 50%;
        text-align: center;
        position: relative;
        span{
            position: absolute;
            bottom: -15px;
            left: 44%;
            display: inline-block;
            width: 50px;
            height: 9px;
            background: #007aff;
        }
    }
}
.content{
    width: 100%;
    overflow-y: auto;
    height: 500px;
    .person{
        box-sizing: border-box;
        padding: 30px;
        background: #ffffff;
        border-bottom: 1px solid #e5e5e5;
        .name{
            display: flex;
            align-items: center;
            .img{
                width: 75px;
                height: 75px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .txt{
                font-size: 26px;
                color: #666666;
                margin-left: 30px;
            }
        }
        .discuss{
            font-size: 28px;
            color: #000000;
            margin-top: 30px;
        }
        .date{
            font-size: 24px;
            margin-top: 28px;
            color: #999999;
        }
    }
    .more{
        font-size: 26px;
        width: 100%;
        height: 50px;
        color: #333;
        text-align: center;
        line-height: 50px;
    }
}
.schedule{
    width: 100%;
    box-sizing: border-box;
    padding: 30px;
    img{
        width: 100%;
        height: 100%;
    }
}
/deep/.prism-big-play-btn{
    left: 42%!important;
    bottom: 35%!important;
}
    </style>